function SpatialEnrollee() {
    var lEnrollee = new Enrollee;
    lEnrollee.FullName = '- unknown -';
    lEnrollee.PrimaryId = '- unknown -';

    return lEnrollee;
}
if (typeof exports !== 'undefined') {
    module.exports = SpatialEnrollee;
}